module.exports = __webpack_public_path__ + "static/media/edi4.0845ae77.jpeg";